import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import $axios from '@/axios-instance'
import store from '@/store'

window.Pusher = Pusher

let echo = null

const stripProtocol = (value) => value.replace(/^https?:\/\//, '').replace(/^wss?:\/\//, '')

const realtimeHost = () => {
  const tenant = store.state.tenant
  const template = process.env.VUE_APP_REALTIME_WS_HOST
  if (template) {
    // Allow a {tenant} placeholder so one value works for every tenant locally
    // (e.g. "{tenant}.lvh.me" -> "ecci.lvh.me"); mirrors prod's per-tenant subdomain.
    return stripProtocol(template).replace('{tenant}', tenant)
  }

  return `${tenant}.realtime.bizz-dome.com`
}

const realtimePort = (fallback) => {
  const value = process.env.VUE_APP_REALTIME_WS_PORT
  return value ? parseInt(value, 10) : fallback
}

// WS path prefix for hosts that don't encode the tenant as a subdomain (e.g. the
// shared *.workers.dev gateway on staging). pusher-js prepends `wsPath` to
// `/app/{key}`, so "/t" -> "/t/{tenant}/app/{key}", which the gateway routes by
// path. Empty (the default) preserves the per-subdomain model used in production.
const wsPath = () => {
  const prefix = process.env.VUE_APP_REALTIME_WS_PATH
  if (!prefix) {
    return ''
  }
  return `${prefix.replace(/\/$/, '')}/${store.state.tenant}`
}

const forceTls = () => process.env.VUE_APP_REALTIME_FORCE_TLS !== 'false'

export const getEcho = () => {
  if (echo) {
    return echo
  }

  const secure = forceTls()

  echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY || 'bizzdome-local-key',
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER || 'mt1',
    wsHost: realtimeHost(),
    wsPath: wsPath(),
    wsPort: realtimePort(secure ? 443 : 80),
    wssPort: realtimePort(443),
    forceTLS: secure,
    // pusher-js's only WebSocket transport is "ws"; TLS is selected by forceTLS
    // (-> wss), not by a "wss" transport name. Listing "wss" leaves no usable
    // transport and the connection silently fails, so keep this as ["ws"].
    enabledTransports: ['ws'],
    disableStats: true,
    authorizer: (channel) => ({
      authorize(socketId, callback) {
        $axios
          .post('/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => callback(false, response.data))
          .catch((error) => callback(true, error))
      },
    }),
  })

  return echo
}

// Avisa cada vez que la conexión vuelve después de cortarse (no la primera
// vez que conecta). Los eventos que llegaron mientras estaba caída se
// perdieron: quien dependa de ellos vuelve a pedir su estado.
export const onReconnected = (callback) => {
  const connection = getEcho().connector.pusher.connection
  let connectedOnce = connection.state === 'connected'
  const handler = ({ current }) => {
    if (current !== 'connected') {
      return
    }
    if (connectedOnce) {
      callback()
    }
    connectedOnce = true
  }
  connection.bind('state_change', handler)

  return () => connection.unbind('state_change', handler)
}

export const socketId = () => {
  try {
    return echo ? echo.socketId() : null
  } catch (e) {
    return null
  }
}

export const leaveChannel = (channelName) => {
  if (!echo || !channelName) {
    return
  }

  echo.leave(channelName)
}

export const disconnectEcho = () => {
  if (!echo) {
    return
  }

  echo.disconnect()
  echo = null
}
